<div class="row p-0 m-0">
	<div class="d-flex align-items-center gap-2 p-0 col-8 position-relative tr-blur">
	    <tr-skeleton-image></tr-skeleton-image>
	    <tr-double-line></tr-double-line>
	</div>
	<div class="col-4 d-flex align-items-start position-relative px-0 justify-content-center tr-blur">
	    <tr-single-line [width]="50"></tr-single-line>
	</div>
</div>